import React, { Component } from "react";
import { connect } from "react-redux";
import { Select } from "@rmwc/select";
import { TextField } from "@rmwc/textfield";
import prequotebuilding from "../../../assets/images/prequotebuilding.png";
import {
  handleSaveLatter,
  onquoteTextFiledChangeValue,
  onSubmit,
} from "../../../action/quote_order/quote.action.js";
import * as validate from "../../Modals/validations";
import {
  onSubmitState,
  updatePreQuoteErr,
  showStateField,
  getBuildingData,
  getSelectedTabstate,
  zipCodeError,
  updatePostData,
  setZipCodeVal,
  savePriceComparisionDataForNotLoggedIn,
} from "../../../action/index.js";
import { stateManufacturerChange } from "../../../action/manufacturers_auth/manufacture.action.js";
import logoSvg from '../../../assets/images/sensei-new-logo-2.0.svg'
import StateDropdown from "./StateDropdown.js";
import { getDealerStateList } from "../../../action/manufacturers_auth/manufacture.action.js";

class PreQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: "fname",
      next: "email",
      prev: "",
      showInfoError: false,
      showErrM: false,
      called: false,
      defaultStateNotSelected:true,
    };
  }

  actionChange = (e, curr, next, prev) => {
    e.preventDefault();
    this.setState({
      current: curr,
      next: next,
      prev: prev,
      showInfoError: false,
      showErrM: false,
      called: false,
    });
  };

  callStateFieldFn = () => {
    this.props.updatePreQuoteErr(true);
    if (this.props.const_var.apiCalledforState == false) {
      this.props.getDealerStateList();
    }
  };

  handleZipCode = (e) => {
    let zipCode = e.target.value;
    if (this.props.const_var.bjDData.length > 0) {
      this.props.updatePreQuoteErr(false, true);
    }
    this.setState({
      showInfoError: false,
    });
    this.props.onquoteTextFiledChangeValue(e, "zipcode", "Zip Code", "", true);
    this.props.setZipCodeVal(zipCode);
    if (
      this.props.const_var.ziperrormsg != undefined &&
      this.props.const_var.ziperrormsg != ""
    ) {
      this.props.zipCodeError("");
      this.props.showStateField(false, false);
    }
    let number = /^(0|[0-9]*)$/;
    if (zipCode && zipCode.length > 4 && number.test(zipCode)) {
      this.props.getDealerStateList(false, true, zipCode);
    }
  };

  submitFormAction = (e) => {
    e.preventDefault();
    if (
      this.props.const_var.showStateField == true ||
      this.props.const_var.showStateOnly == true
    ) {
      if (
        this.props.params.p_s_n != "" &&
        this.props.params.p_s_n != undefined
      ) {
        this.props.onSubmitState(e, true);
      }
    } else {
      if (this.props.const_var.SApiCalled == true) {
        this.props.submitForm(e);
      }
    }
  };

  render() {
    const { current, called } = this.state;
    if (
      this.props.const_var.showStateOnly == true &&
      this.props.const_var.apiCalledforState == false &&
      this.props.const_var.bjDData.length == 0 &&
      this.props.const_var.preQuoteApiCalled == true &&
      called == false
    ) {
      this.setState({
        called: true,
      });
      // this.props.const_var.KLinkDataUpdate = false;
      this.props.getDealerStateList();
    }
    return (
      <>
        <div className="pre-image-forground">
          <img
            src={process.env.REACT_APP_BASE_URL + prequotebuilding}
            className="img-fluid"
          />
        </div>
        <form
          id="configuration"
          name="configuration"
          className="container m-0"
          onSubmit={(e) => this.submitFormAction(e)}
        >
          <div className="pretext-logo">
            <img
              src={window.location.origin + '/logo.svg'}
              // src={logoSvg}
              className={
                this.props.const_var.crmSetting.is_CRM == true ||
                this.props.const_var.crmSetting.main_domain_url ==
                  "sensei3d.com" ||
                this.props.const_var.crmSetting.main_domain_url ==
                  "vaibhavcibirix.com"
                  ? "sensei3dlogo"
                  : ""
              }
            />
          </div>

          <div
            className={`state-all-content pre-quote ${
              this.props.const_var.showReportLoading == true
                ? "form-submiting"
                : ""
            }`}
          >
            <div className="state-text-content">
              <div className="span-1 desc-block">
                Design your building in 3D, Please provide us with some basic
                information..
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 display-flex">
                {this.props.const_var.isKLinkEnable != true &&
                  current == "fname" && (
                    <>
                      <div className="form-group">
                        <div className="label-container">
                            <div className="label">
                                Name <span className="required-field">*</span>
                            </div>
                            <div className="sub-label">
                                Let’s start with your full name
                            </div>  
                        </div>
                        <div
                          className={
                            this.props.const_var.displayerrorMessage
                              .full_name == "" ||
                            this.props.const_var.displayerrorMessage
                              .full_name == undefined
                              ? "floating-label-input"
                              : "floating-label-input invalid-input"
                          }
                        >
                          <TextField
                            placeholder="Type"
                            className="astrick"
                            name="full_name"
                            value={this.props.const_var.post_data.full_name}
                            onChange={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "full_name",
                                "Full Name",
                                "",
                                true
                              )
                            }
                            onBlur={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "full_name",
                                "Full Name"
                              )
                            }
                            maxLength={50}
                            autoFocus={true}
                          />
                          {this.props.const_var.post_data.full_name != "" &&
                            this.props.const_var.post_data.full_name !=
                              undefined && (
                              <>
                                <span className="error-icon icon-info-ico"></span>
                                <div
                                  className="errorMessage"
                                  id="fnameErrorMessage"
                                >
                                  <div className="inn">
                                    <span></span>
                                    {
                                      this.props.const_var.displayerrorMessage
                                        .full_name
                                    }
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                      <div className="action-sec">
                        <button
                          className={`pushable pushable-with-left-right pushable-xm ${
                            this.props.const_var.displayerrorMessage
                              .full_name == "" ||
                            this.props.const_var.displayerrorMessage
                              .full_name == undefined
                              ? this.props.const_var.post_data.full_name !=
                                  "" &&
                                this.props.const_var.post_data.full_name !=
                                  undefined
                                ? ""
                                : "disabled"
                              : "disabled"
                          }`}
                          onClick={(e) => {
                            (this.props.const_var.displayerrorMessage
                              .full_name == "" ||
                              this.props.const_var.displayerrorMessage
                                .full_name == undefined) &&
                              this.props.const_var.post_data.full_name != "" &&
                              this.props.const_var.post_data.full_name !=
                                undefined &&
                              this.actionChange(e, "email", "fname", "phoneno");
                          }}
                        >
                          <span className="edge"></span>
                          <div className="front justify-content-center">
                            <span className="saving-effect">
                              <span></span>
                              <span></span>
                              <span></span>
                            </span>
                            <div className="front-left">
                              <span className="text text-uppercase d-flex align-items-center">
                                Next
                                <i className="icon icon-arrow-double-small" />
                              </span>
                            </div>
                          </div>
                        </button>
                      </div>
                    </>
                  )}
                {this.props.const_var.isKLinkEnable != true &&
                  current == "email" && (
                    <>
                      <div className="form-group ">
                        <div className="label-container">
                            <div className="label">
                                Email Id<span className="required-field">*</span>
                            </div>
                            <div className="sub-label">
                                We require your email Id to keep you informed &
                                provide important updates
                            </div>
                        </div>
                        <div
                          className={
                            this.props.const_var.displayerrorMessage.email ==
                              "" ||
                            this.props.const_var.displayerrorMessage.email ==
                              undefined
                              ? "floating-label-input"
                              : "floating-label-input invalid-input"
                          }
                        >
                          <TextField
                            value={this.props.const_var.post_data.email}
                            placeholder="Type"
                            className="astrick"
                            name="email"
                            onChange={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "email",
                                "Email",
                                "",
                                true
                              )
                            }
                            onBlur={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "email",
                                "Email"
                              )
                            }
                            autoFocus={true}
                          />
                          {this.props.const_var.post_data.email != "" &&
                            this.props.const_var.post_data.email !=
                              undefined && (
                              <>
                                <span className="error-icon icon-info-ico"></span>
                                <div
                                  className="errorMessage"
                                  id="emailErrorMessage"
                                >
                                  <div className="inn">
                                    <span></span>
                                    {
                                      this.props.const_var.displayerrorMessage
                                        .email
                                    }
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                      <div className="action-sec">
                        <button
                          className={`pushable pushable-with-left-right pushable-white pushable-xm ${
                            this.props.const_var.displayerrorMessage.email ==
                              "" ||
                            this.props.const_var.displayerrorMessage.email ==
                              undefined
                              ? this.props.const_var.post_data.email != "" &&
                                this.props.const_var.post_data.email !=
                                  undefined
                                ? ""
                                : "disabled"
                              : "disabled"
                          }`}
                          onClick={(e) => {
                            (this.props.const_var.displayerrorMessage.email ==
                              "" ||
                              this.props.const_var.displayerrorMessage.email ==
                                undefined) &&
                              this.props.const_var.post_data.email != "" &&
                              this.props.const_var.post_data.email !=
                                undefined &&
                              this.actionChange(
                                e,
                                "phoneno",
                                "zipcode",
                                "email"
                              );
                          }}
                        >
                          <span className="edge"></span>
                          <div className="front justify-content-center">
                            <span className="saving-effect">
                              <span></span>
                              <span></span>
                              <span></span>
                            </span>
                            <div className="front-left">
                              <span className="text text-uppercase d-flex align-items-center">
                                Next
                                <i className="icon icon-arrow-double-small" />{" "}
                              </span>
                            </div>
                          </div>
                        </button>
                        <button
                          className={`link-text`}
                          onClick={(e) =>
                            this.actionChange(e, "fname", "email", "")
                          }
                        >
                          <i className="icon icon-arrow-left" /> Prev
                        </button>
                      </div>
                    </>
                  )}
                {this.props.const_var.isKLinkEnable != true &&
                  current == "phoneno" && (
                    <>
                      <div className="form-group ">
                        <div className="label-container">
                            <div className="label">
                                Phone Number
                                <span className="required-field">*</span>
                            </div>
                            <div className="sub-label">
                                Your phone number will enable us to reach you
                                quickly and efficiently.
                            </div>
                        </div>
                        <div
                          className={
                            this.props.const_var.displayerrorMessage.phone_no ==
                              "" ||
                            this.props.const_var.displayerrorMessage.phone_no ==
                              undefined
                              ? "floating-label-input"
                              : "floating-label-input invalid-input"
                          }
                        >
                          <TextField
                            value={this.props.const_var.post_data.phone_no}
                            placeholder="Type"
                            className="astrick"
                            maxLength="10"
                            onKeyUp={(e) => validate.numericCheck(e)}
                            name="phone_no"
                            onChange={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "phone_no",
                                "Number",
                                "",
                                true
                              )
                            }
                            onBlur={(e) =>
                              this.props.onquoteTextFiledChangeValue(
                                e,
                                "phone_no",
                                "Number"
                              )
                            }
                            autoFocus={true}
                          />
                          {this.props.const_var.post_data.phone_no != "" &&
                            this.props.const_var.post_data.phone_no !=
                              undefined && (
                              <>
                                <span className="error-icon icon-info-ico"></span>
                                <div
                                  className="errorMessage w300 h38"
                                  id="numberErrorMessage"
                                >
                                  <div className="inn">
                                    <span></span>
                                    {
                                      this.props.const_var.displayerrorMessage
                                        .phone_no
                                    }
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                      <div className="action-sec">
                        <button
                          className={`pushable pushable-with-left-right pushable-white pushable-xm ${
                            this.props.const_var.displayerrorMessage.phone_no ==
                              "" ||
                            this.props.const_var.displayerrorMessage.phone_no ==
                              undefined
                              ? this.props.const_var.post_data.phone_no != "" &&
                                this.props.const_var.post_data.phone_no !=
                                  undefined
                                ? ""
                                : "disabled"
                              : "disabled"
                          }`}
                          onClick={(e) => {
                            (this.props.const_var.displayerrorMessage
                              .phone_no == "" ||
                              this.props.const_var.displayerrorMessage
                                .phone_no == undefined) &&
                              this.props.const_var.post_data.phone_no != "" &&
                              this.props.const_var.post_data.phone_no !=
                                undefined &&
                              this.actionChange(
                                e,
                                "zipcode",
                                "address",
                                "phoneno"
                              );
                          }}
                        >
                          <span className="edge"></span>
                          <div className="front justify-content-center">
                            <span className="saving-effect">
                              <span></span>
                              <span></span>
                              <span></span>
                            </span>
                            <div className="front-left">
                              <span className="text text-uppercase">
                                Next
                                <i className="icon icon-arrow-double-small" />{" "}
                              </span>
                            </div>
                          </div>
                        </button>
                        <button
                          className={`link-text`}
                          onClick={(e) =>
                            this.actionChange(e, "email", "fname", "phoneno")
                          }
                        >
                          <i className="icon icon-arrow-left" /> Prev
                        </button>
                      </div>
                    </>
                  )}
                {(this.props.const_var.isKLinkEnable == true ||
                  current == "zipcode") && (
                  <>
                    {this.props.const_var.showStateOnly != true && (
                      <div
                        className={
                          "form-group " +
                          (this.props.const_var.showStateField == true &&
                          this.props.const_var.showStateOnly == false
                            ? "dbl-input-field"
                            : "")
                        }
                      >
                        <div className="label-container">
                            <div className="label">
                                Zip Code<span className="required-field">*</span>
                            </div>
                            <div className="sub-label">
                                Please enter your postal code
                            </div>
                        </div>
                        <div
                          className={
                            (this.props.const_var.displayerrorMessage.zipcode ==
                              "" ||
                              this.props.const_var.displayerrorMessage
                                .zipcode == undefined) &&
                            (this.props.const_var.ziperrormsg == "" ||
                              this.props.const_var.ziperrormsg == undefined)
                              ? "floating-label-input"
                              : "floating-label-input invalid-input"
                          }
                        >
                          <TextField
                            placeholder="Type"
                            maxLength="5"
                            className="astrick"
                            name="zipcode"
                            value={this.props.const_var.zipCode}
                            onKeyUp={(e) => validate.numericCheckForZipCode(e)}
                            onChange={(e) => this.handleZipCode(e)}
                            autoFocus={true}
                          />
                          {
                            // this.props.const_var.showStateField != true &&
                            (this.state.showInfoError != true ||
                              (this.state.showInfoError == true &&
                                this.state.showErrM == true)) &&
                              ((this.props.const_var.zipCode != "" &&
                                this.props.const_var.zipCode != undefined) ||
                                (this.props.displayerrorMessage.zipcode != "" &&
                                  this.props.displayerrorMessage.zipcode !=
                                    undefined)) && (
                                <>
                                  <span className="error-icon icon-info-ico"></span>
                                  <div
                                    className={
                                      "errorMessage w250 " +
                                      (this.props.const_var.ziperrormsg != "" &&
                                      this.props.const_var.ziperrormsg !=
                                        undefined &&
                                      this.props.const_var.ziperrormsg.includes(
                                        "not providing service"
                                      )
                                        ? " w300"
                                        : "")
                                    }
                                    id="zcodeErrorMessage"
                                  >
                                    <div className="inn">
                                      <span></span>
                                      {this.props.displayerrorMessage.zipcode ||
                                        this.props.const_var.ziperrormsg}
                                    </div>
                                  </div>
                                </>
                              )
                          }
                        </div>
                      </div>
                    )}
                    {(this.props.const_var.showStateField == true ||
                      this.props.const_var.showStateOnly == true) && (
                      <div
                        className={
                          "form-group zIndex1 " +
                          (this.props.const_var.showStateOnly == false &&
                          this.props.const_var.ziperrormsg != "" &&
                          this.props.const_var.ziperrormsg != undefined
                            ? "dbl-input-field"
                            : "")
                        }
                      >
                        <div className="floating-label-input floating-label-inside text-left">
                            <div className="label-container">
                                <div className="label">State</div>
                                <div className="sub-label">
                                    Please enter your installation state.
                                </div>

                            </div>
                            {this.props.const_var.bjD.length != undefined ? (
                                <>
                                    <StateDropdown 
                                        onChange={(value) =>{
                                            this.setState({
                                              defaultStateNotSelected:false
                                            })
                                            this.props.stateManufacturerChange(
                                                value,
                                                "state"
                                            )
                                          }
                                        }
                                        value={
                                            this.props.params.p_s_n == ""
                                                ? "Select"
                                                : this.props.params.p_s_n
                                        }
                                        options={
                                            this.props.const_var.bjD.map(
                                                (val, index) => {
                                                    return { value: val.id, label: val.name };
                                                }
                                        )}
                                    />
                                    
                                </>
                            ) : null}
                        </div>
                      </div>
                    )}
                    <div className="action-sec">
                      <button
                        className={`pushable pushable-with-left-right pushable-white pushable-xm ${
                          this.props.const_var.SApiCalled == true
                            ? this.props.const_var.showStateOnly == true
                              ? ""
                              : this.props.const_var.showStateField == true
                              ? this.props.params.p_s_n == "" ||
                                this.props.params.p_s_n == 0
                                ? "disabled"
                                : ""
                              : this.props.const_var.displayerrorMessage
                                  .zipcode == "" ||
                                this.props.const_var.displayerrorMessage
                                  .zipcode == undefined
                              ? this.props.const_var.zipCode != "" &&
                                this.props.const_var.zipCode != undefined
                                ? ""
                                : "disabled"
                              : "disabled"
                            : "disabled"
                        }`}
                        onClick={() => {
                          if (
                            this.props.const_var.showStateField == true ||
                            (this.props.const_var.showStateOnly == true &&
                              this.props.params.p_s_n != "" &&
                              this.props.params.p_s_n != undefined)
                          ) {
                            const selectedStateData = this.props.const_var.bjDData?.find(state => state.id == this.props.params.p_s_n);
                         
                            if(selectedStateData && !this.props.const_var.loginSession && selectedStateData?.manufacturer_list?.price_comparision?.length > 0) {
                               const key = `selectedState_${this.props.params.p_s_n}`;
                               let mfgList = [selectedStateData?.manufacturer_list,...selectedStateData?.manufacturer_list?.price_comparision]
                               this.props.savePriceComparisionDataForNotLoggedIn(key,mfgList)
                            }
                            if(this.props.const_var.bjD!=undefined && this.props.const_var.bjD.length>0 && this.state.defaultStateNotSelected == true){
                              this.props.stateManufacturerChange(
                                this.props.params.p_s_n,
                                "state"
                              )
                            }
                            if (this.props.callApifun === false) {
                              this.props.getSelectedTabstate("buildingtypetab");
                              if (this.props.const_var.showStateOnly != true) {
                                this.props.updatePostData();
                              }
                            } else {
                              this.props.getBuildingData(
                                this.props.params,
                                "direct"
                              );
                            }
                          }
                        }}
                      >
                        <span className="edge"></span>
                        <div className="front justify-content-center">
                          <span className="saving-effect">
                            <span></span>
                            <span></span>
                            <span></span>
                          </span>
                          <div className="front-left">
                            <span className="text text-uppercase">
                              Next{" "}
                              <i className="icon icon-arrow-double-small" />
                            </span>
                          </div>
                        </div>
                      </button>
                      {this.props.const_var.showStateOnly == false && (
                        <button
                          className={`link-text`}
                          onClick={(e) =>
                            this.actionChange(e, "phoneno", "zipcode", "email")
                          }
                        >
                          <i className="icon icon-arrow-left" /> Prev
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
}
const mapStoreToProps = (state) => {
  return { ...state.reducer, ...state.quoteReducer };
};
const mapDispatchToProps = {
  handleSaveLatter,
  onquoteTextFiledChangeValue,
  onSubmit,
  stateManufacturerChange,
  onSubmitState,
  updatePreQuoteErr,
  showStateField,
  getBuildingData,
  getSelectedTabstate,
  zipCodeError,
  updatePostData,
  setZipCodeVal,
  getDealerStateList,
  savePriceComparisionDataForNotLoggedIn,
};
export default connect(mapStoreToProps, mapDispatchToProps)(PreQuote);
